export default {
      id: "notifications-icon-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "sprite.svg#notifications-icon",
      toString: function () {
        return this.url;
      }
    }